import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../layout/Header";
import Toolbar from "../navigation/Toobar";
import Chat from "../components/common/Chat";

function Withdraw({items, userData, transactionData, hasEWallet, general}){
    const [activeItem, setActiveItem] = useState(null); 
  const [activeAmount, setActiveAmount] = useState(""); 
  const [icon, setIcons] = useState(''); 
  const [selectedAccount, setSelectedAccount] = useState("");
  const [submitLoading, setSubmitLoading] = useState(false); 
  const [showModal, setShowModal] = useState(false); 
  const [modalMessage, setModalMessage] = useState(""); 
  // Removed unused state variable to avoid confusion
  const [numbers, setNumbers] = useState([]);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const remoteId = localStorage.getItem('remote_id');
  const amounts = ["2000", "3000", "5000", "10000", "15000", "20000", "25000", "1000", "500"];
  const firstItem = items.find(item => item.status === "active");
	const [pgs, setPgs] = useState([]);
	const [name, setName] = useState('');
	const withdrawDisabled = Number(general?.withdrawal_status) === 0;
	

  useEffect(() => {
		const uniquePaymentMethods = [];
		const seenNames = new Set();
		items.forEach((item) => {
			if (item.name && !seenNames.has(item.name.toLowerCase())) {
				seenNames.add(item.name.toLowerCase());
				uniquePaymentMethods.push(item);
			}
		});
    if (Number(general?.withdrawal_status) === 0) {
			setPgs([]);
		} else {
			setPgs(uniquePaymentMethods);
		}
		
  }, [items, general]);

  useEffect(() => {
		if (firstItem) {
			setName(firstItem.name);
		}
	 }, [firstItem]);

	const [getotherContracts, setOtherContracts] = useState([]);
 
  const handleItemClick = (id, icon, name) => {
	setActiveItem(id); 
	setIcons(icon);
	setName(name);
  };

  const fetchOtherContracts = async () => {
	if (token) {
		try {
			const response = await fetch(`${process.env.REACT_APP_API_URL}/api/get/other/phone`, {
				method: "GET",
				headers: { Authorization: `Bearer ${token}` },
			});
			if (response.ok) {
				const data = await response.json();
				// Populate getotherContracts for the phone-verification check in handleSubmit
				setOtherContracts(data.data || []);
				let nums = [];
				if (userData?.session_id == 1 && userData?.phone) {
					nums.push(userData.phone);
				}
				if (data?.data && data.data.length > 0) {
					data.data.forEach((item) => {
						if (item.isverify) nums.push(item.contract_value);
					});
				}
				setNumbers(nums);
				if (nums.length > 0) setSelectedAccount(nums[0]);
			} else {
				console.error("Failed to fetch contracts");
			}
		} catch (error) {
			console.error("Error fetching contracts:", error);
		}
	}
  };

  // Re-run when userData loads so the primary phone is included in the list
  useEffect(() => {
	  fetchOtherContracts();
  }, [userData]);

  // Set default active item + icon + name whenever the items list resolves
  useEffect(() => {
	  if (firstItem) { 
		setActiveItem(firstItem.id); 
		setIcons(firstItem.icon);
		setName(firstItem.name);
	  }
  }, [firstItem]);

  const handleSelection = (value) => {
	setSelectedAccount(value);
  };

  const handleAmountClick = (amount) => {
	setActiveAmount(amount); 
  };
  const checkUserEligibility = async () => {
	try {
	  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/userwithdrawcheck?remote_id=${remoteId}`, {
		method: 'GET',
		headers: {
		  'Content-Type': 'application/json',
		  'Authorization': `Bearer ${token}`,
		},
	  });
  
	  const data = await response.json();
	  console.log('API response data:', data);
  
	  if (!response.ok) {
		  if (response.status === 400) {
			if (data.error.match(/Date of Birth/i)) { 
				setModalMessage(`<a href="/profile">${data.error}</a>`);
			} else {
				setModalMessage(data.error || '<a href="/turnover-record">Please complete your turnover and try again.</a>');
			}
		  setShowModal(true);
		  return false;
		} else {
		  setModalMessage(data.error || 'An error occurred.');
		  setShowModal(true);
		  return false;
		}
	  }
  
	  if (data.success) {
		// User is eligible for withdrawal
		return true;
	  } else {
		// Fallback for other cases
		setModalMessage('An unknown error occurred.');
		setShowModal(true);
		return false;
	  }
	} catch (error) {
	  return false;
	}
  };
  

  const handleSubmit = async () => {
	// Guard: withdrawal under maintenance
	if (withdrawDisabled) {
		setModalMessage("Withdrawal is currently under maintenance. Please try again later.");
		setShowModal(true);
		return;
	}
	
	let isVerified = (userData?.session_id=='1') ? true : false;
	if (!isVerified) {
		if (getotherContracts && getotherContracts.length > 0) {
			isVerified = getotherContracts.some(contract => contract.isverify === 1);
		}
		if (!isVerified) {
			setModalMessage(`<a href="/profile">Please verify your phone number first.</a>`);
			setShowModal(true);
			return;
		}
	}
	 
	if (transactionData && transactionData.length > 0) {
		for (let trns of transactionData) {
			if (trns.action == "withdraw" && trns.key === "0") {
				setModalMessage(`You already have a withdraw request pending. Please wait for it to be processed before making another withdraw request.`);
				setShowModal(true);
				return;
			}
		}
	}
	  
	if (!activeAmount) {
		setModalMessage("Amount is required.");
		setShowModal(true);
		return;
	}
	
		if (!selectedAccount) {
		setModalMessage("Account number is required.");
		setShowModal(true);
		return;
		}

		if (isNaN(selectedAccount)) {
		setModalMessage("Account number is required.");
		setShowModal(true);
		return;
		}
		if (!/^\d+$/.test(selectedAccount)) {
			setModalMessage("Account number must contain only digits.");
			setShowModal(true);
			return;
			}


	if (!activeItem) {
		setModalMessage("Please select your payment method.");
		setShowModal(true);
		return;
	}
  
	// Check user eligibility
	const eligible = await checkUserEligibility();
	if (!eligible) {
		return;
	}
  
	setSubmitLoading(true);
  
	const remoteId = localStorage.getItem("remote_id");
  
	const requestBody = {
		remote_id: remoteId,
		account_number: selectedAccount,
		amount: activeAmount,
		payment_id: hasEWallet ? 0 : activeItem,
		provider: hasEWallet ? name : name,
	};
  
	console.log(requestBody);
  
	try {
	  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/submit-withdraw`, {
		method: "POST",
		headers: {
		  "Content-Type": "application/json",
		  Authorization: `Bearer ${token}`,
		},
		body: JSON.stringify(requestBody),
	  });
  
	  if (!response.ok) {
		const errorData = await response.json();
		setModalMessage(errorData.error);
		setShowModal(true);
		return;
	  }
  
	  const data = await response.json();
  
	  if (data.success) {
		setModalMessage("Withdrawal successful!");
		setShowModal(true);
		navigate("/transaction-record");
	  } else {
		setModalMessage(data.message);
		setShowModal(true);
	  }
	} catch (error) {
	  setModalMessage("An error occurred. Please try again.");
	  setShowModal(true);
	} finally {
	  setSubmitLoading(false);
	}
  };

    return(
        <div className="v-application--wrap">
  <div>
    {/**/}
    <div className="row no-gutters">
      <Header/>
    </div>
    
   
    
    <div className="body">
      <div className>
        <div className="row no-gutters">
        
          <div className="col col-12">
            <div className="px-0" style={{height: '100%'}}>
              <div className="row hidden-md-and-up mobile-header no-gutters">
                <div className="mobile-header-item col col-6 ">
                  <Link to="/deposit" className="router-link-exact-active" style={{textDecoration: 'unset !important'}}><span>Deposit</span></Link>
                </div>
                <div  className="text-center mobile-header-item col col-6 router-link-active selected">
                  <Link to="/withdrawal" className style={{textDecoration: 'unset !important'}}><span>Withdrawal</span></Link>
                </div>
              </div>
              <div className="desktop_depo_card v-card v-sheet theme--light">
                {/**/}
                <div className="v-card__title hidden-sm-and-down pl-3 ml-7"><label className="--v-primary-base depo-desktop-txt text-left text-capitalize">Deposit</label></div>
                <div className="bank-detail-card deposit-card v-card v-sheet theme--light elevation-0">
                  <div>
                    {withdrawDisabled && (
                      <div className="row no-gutters px-8 pt-4">
                        <div className="col">
                          <div className="v-alert theme--light" style={{background:'#fff3cd', border:'1px solid #ffeeba', color:'#856404', borderRadius:'8px', padding:'12px'}}>
                            Withdrawal is under maintenance. Please try again later.
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="row breakpoint no-gutters align-end px-8 pt-4">
                      <div className="col col-auto">
                        <div className="hidden-md-and-up">
                          <label className="input-field-label ma-0 text-capitalize d-block pb-1">
                            Payment Methods
                          </label>
                        </div>
                      
                        <div className="row py-2 mb-3 no-gutters" style={{gap: '0.5rem'}}>
                            {pgs.length === 0 && (
							<div className="no-payment-method">No widthdraw methods available.<br />Try again later.</div>
						)}
                          {pgs.map((item) =>
                            item.status === "active" && (
                              <div className="col col-auto" key={item.name}>
                                <button
                                  type="button"
                                  onClick={() => handleItemClick(item.id, item.icon, item.name)}
                                  className={`v-btn active-gateway-button ${
                                    name === item.name ? "v-btn--active" : ""
                                  } v-btn--outlined theme--light v-size--default pa-2 gateway-button mobile-paymentMethod`}
                                  style={{ height: "100%", width: "100px" }}
                                >
                                  <span className="v-btn__content">
                                    <img
                                      src={`${item.icon}`}
                                      alt={item.name}
                                    />
                                  </span>
                                </button>
                              </div>
                            )
                          )}

                        </div>
                      </div>
                    </div>
                    {/**/}{/**/}
                    <form noValidate="novalidate" className="v-form">
                    
                      <div className="row breakpoint no-gutters align-end px-8 pt-4">
                        <div className="col-md-6 col">
                          <div className="mobile">
                            <div className="row no-gutters justify-space-between">
                              <div className="col col-10">
                                <label className="input-field-label ma-0 text-capitalize d-block pb-1" style={{float: 'left'}}> Withdrawal amount<span className="red--text ml-1">*</span></label>
                              </div>
                              
                              <div className="col col-12">
                                <div className="v-input input-field elevation-0 hide-details v-input--is-label-active v-input--is-dirty theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder">
                                  <div className="v-input__control">
                                    <div className="v-input__slot">
                                      <fieldset aria-hidden="true">
                                        <legend style={{width: '0px'}}><span className="notranslate">​</span></legend>
                                      </fieldset>
                                      <div className="v-text-field__slot">
                                       <input
                                        type="number"
                                        name="amount"
                                        placeholder="500 - 25,000TK"
                                        disabled={withdrawDisabled}
                                        value={activeAmount}
                                        onChange={(e) => setActiveAmount(e.target.value)} 
                                        onClick={(e) => e.stopPropagation()} 
                                      />
                                       </div>
                                    </div>
                                    <div className="v-text-field__details">
                                      <div className="v-messages theme--light"><div className="v-messages__wrapper" /></div>
                                    </div>
                                  </div>
                                </div>
                                {/**/}{/**/}
                              </div>
                            </div>
                          </div>
                          {/**/}
                        </div>
                      </div>
                      <div className="row pb-2 breakpoint no-gutters align-end px-8 pt-4">
                        <div className="col">
                          <div className="row no-gutters">
                           {amounts.map((amount) => (
                              <div className="pr-2 pb-2 hidden-md-and-up col col-4" key={amount}>
                                <button
                                  type="button"
                                  onClick={() => handleAmountClick(amount)}
                                  className={`pa-2 full-width theme-button font-weight-bold hidden-md-and-up mobile-amount-button v-btn v-btn--has-bg theme--light v-size--default ${
                                    activeAmount === amount ? "active-amount-button v-btn--active" : ""
                                  }`}
                                  disabled={withdrawDisabled}
                                  style={{ height: "auto" }}
                                >
                                  <span className="v-btn__content">
                                    
                                    {amount}
                                  </span>
                                </button>
                              </div>
                            ))}

                          
                         
                          
                            
                         
                         
                           
                          </div>
                        </div>
                      </div>
                      {/**/}
                      <div className="row pb-3 hidden-md-and-up breakpoint no-gutters align-end px-8 pt-1">
                        <div className="col-md-5 col-lg-4 col"><hr role="separator" aria-orientation="horizontal" className="v-divider theme--light" /></div>
                      </div>
                      <div className="row breakpoint no-gutters align-end px-8">
                        <div className="col-md-6 col">
                          <div className="depo-box mobile" light remark="fieldHint.promotionRemark">
                            <div className="row no-gutters justify-space-between">
                              <div className="col col-10">
                                <label className="input-field-label ma-0 text-capitalize d-block pb-1" style={{float: 'left'}}> Account Number<span className="red--text ml-1">*</span></label>
                              </div>
                              <div className="col col-2">{/**/}</div>
                              <div className="col col-12">

                               
                                <div className="v-input input-field v-input--is-label-active v-input--is-dirty theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-select">
                                 <select
                            onChange={(e) => handleSelection(e.target.value)}
                            value={selectedAccount || ""}
                            className="v-input v-text-field v-select pa-2"
                            style={{
                                width: "100%",
                                borderRadius: "8px",
                                padding: "8px 12px",
                                border: "1px solid #ccc",
                                background: "#fff",
                                marginBottom: "10px",
                            }}
                              disabled={withdrawDisabled}
                            >
                            <option value="">Not selected Number</option>
                            {numbers.length > 0 &&
                                numbers.map((contract, index) => (
                                <option key={index} value={contract}>
                                    {contract}
                                </option>
                                ))}
                            </select>


     
      
    
                                </div>


                               
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                    <div className="row pb-5 breakpoint no-gutters align-end px-8">
                      <div className="col-md-6 col">
                        <button onClick={handleSubmit} type="button" className="theme-button depo-width black--text v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default deposit-btn buttonPrimary" disabled={withdrawDisabled || submitLoading} aria-disabled={withdrawDisabled || submitLoading}>
                          <span className="v-btn__content">
                            {withdrawDisabled ? 'Unavailable (Maintenance)' : 'Submit'}
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {showModal && (
                 <div role="document" tabIndex={0} data-v-c5353408 className="v-dialog__content v-dialog__content--active" style={{zIndex: 202}}>
                <div className="v-overlay v-overlay--active theme--dark" style={{zIndex: 201}}>
              <div className="v-overlay__scrim" style={{opacity: '0.46', backgroundColor: 'rgb(33, 33, 33)', borderColor: 'rgb(33, 33, 33)'}} />
              <div className="v-overlay__content" />
            </div>

                <div className="v-dialog v-dialog--active v-dialog--persistent" style={{transformOrigin: 'center center', maxWidth: '400px'}}>
                  <div data-v-c5353408 className="dialog-card v-card v-sheet theme--dark">
                    <div data-v-c5353408 className="row no-gutters justify-space-between dialog-header pt-3 px-3">
                      <div data-v-c5353408 className="col col-11">
                        <label data-v-c5353408 className="dialog-title pt-3 ma-0 text-capitalize d-block full-width"> Withdraw Details</label>
                        {/**/}
                      </div>
                      <div data-v-c5353408 className="col col-1"><button onClick={() => setShowModal(false)} data-v-c5353408 type="button" className="v-icon notranslate v-icon--link mdi mdi-close theme--dark dialog-close-icon" /></div>
                      {/**/}
                    </div>
                    <div data-v-c5353408 className="row no-gutters px-3 py-3">
                      <div data-v-c5353408 className="col col-12"><hr data-v-c5353408 role="separator" aria-orientation="horizontal" className="dialog-divider v-divider theme--dark" /></div>
                    </div>
                    <div data-v-c5353408 className="row d-block dialog-row no-gutters pa-3 pt-0">
                     <span dangerouslySetInnerHTML={{ __html: modalMessage }} />
                    </div>
                  </div>
                </div>
              </div>

              ) }
             

            </div>
          </div>
        </div>
        {/**/}
      </div>
      {/**/}
    </div>
   <Toolbar/>
    <Chat/>
  </div>
</div>
    );

}
export default Withdraw;